import request from "@/utils/request";

export function deleteMedia(id) {
  return request({
    url: `/api/media/${id}`,
    method: "delete"
  });
}
